// An inert stand-in for Firebase in the Playgama build (see fb.ts). Every property and call
// returns the stand-in again, nothing is ever sent, promises resolve at once, listeners never
// fire, and "who is signed in" is always nobody, which is what local mode expects.
const NOBODY = new Set(["currentUser"]);
const stub: any = new Proxy(function () {}, {
  get(_t, prop) {
    if (prop === "then") return undefined; // so `await stub` resolves to the stand-in
    if (prop === Symbol.toPrimitive) return () => "";
    if (prop === Symbol.iterator) return function* () {};
    if (prop === "length" || prop === "size") return 0;
    if (prop === "exists" || prop === "empty") return false;
    if (prop === "docs" || prop === "apps") return [];
    if (typeof prop === "string" && NOBODY.has(prop)) return null;
    if (prop === "toJSON") return () => null;
    return stub;
  },
  apply() {
    return stub;
  },
  construct() {
    return stub;
  },
});
export default stub;
